let dispatchFunction;

export const getAppDispatch = () => dispatchFunction;
export const setAppDispatch = (dispatch) => (dispatchFunction = dispatch);
